// extracted by mini-css-extract-plugin
export default {"pageContainer":"MainPage_pageContainer__JPoBu","content":"MainPage_content__TLpyb"};